var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"agent-table-container"},[_c('ve-table',{attrs:{"max-height":"calc(100vh - 35rem)","fixed-header":true,"columns":_vm.columnsTable,"table-data":_vm.tableData}}),_vm._v(" "),(_vm.isLoading)?_c('div',[_c('span',[_vm._v(_vm._s(_vm.$t('CAMPAIGN_REPORTS.TABLE.LOADING_MESSAGE')))])]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }